export default __webpack_public_path__ + "static/working_tek-52d36fcdf21791587635b18c853d5237.webp";